import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { MenuList } from './MenuList';

export interface MainMenuProps {
  title?: string;
  shouldHideContent?: boolean;
  shouldHideInspirationLibrary?: boolean;
  team?: string;
  className?: string;
}

export const MainMenu = ({
  title,
  shouldHideContent,
  shouldHideInspirationLibrary,
  team,
  className,
  ...props
}: MainMenuProps) => {
  const inspirationLibraryPath = `/manage/${team}/inspiration-library`;

  return (
    <MenuList title={title} className={clsx('flex-col sm:flex-row', className)} {...props}>
      {!shouldHideContent && <Link to={`/manage/${team}`}>Content</Link>}
      {!shouldHideInspirationLibrary && <Link to={inspirationLibraryPath}>Inspiration Library</Link>}
    </MenuList>
  );
};
